var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9971 9.5H10.9971C9.8925 9.5 8.99707 10.3954 8.99707 11.5V20.5C8.99707 21.6046 9.8925 22.5 10.9971 22.5H19.9971C21.1016 22.5 21.9971 21.6046 21.9971 20.5V11.5C21.9971 10.3954 21.1016 9.5 19.9971 9.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99707 15.5H3.99707C3.46664 15.5 2.95793 15.2893 2.58286 14.9142C2.20778 14.5391 1.99707 14.0304 1.99707 13.5V4.5C1.99707 3.96957 2.20778 3.46086 2.58286 3.08579C2.95793 2.71071 3.46664 2.5 3.99707 2.5H12.9971C13.5275 2.5 14.0362 2.71071 14.4113 3.08579C14.7864 3.46086 14.9971 3.96957 14.9971 4.5V5.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.07ecf04e08fa5a57ff1331cfa4b52df8.svg";
export { ForwardRef as ReactComponent };